import { styled, TableContainer } from "@mui/material";

export const S = {
    View: styled(TableContainer)(({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.divider}`,
    })),
};
